import {
  SbReactComponentsMap,
  StoryblokClient,
  apiPlugin,
  getStoryblokApi as getStoryblokApiDefault,
  setComponents,
  storyblokInit,
} from "@storyblok/react";

import { PublicConfig } from "../config/public";

let storyblokApi: StoryblokClient | undefined;
let _components: SbReactComponentsMap | undefined;

// One client per process: each has its own 5 req/s throttle queue, so a second
// would double our request rate against Storyblok's limit.
export const AppStoryblokInit = (components?: SbReactComponentsMap): StoryblokClient => {
  if (components) {
    _components = components;
  }

  if (storyblokApi) {
    if (components) {
      setComponents(components);
    }

    return storyblokApi;
  }

  storyblokInit({
    accessToken: PublicConfig.STORYBLOK_API_TOKEN,
    // Only enable the bridge if storyblok env is draft
    bridge: PublicConfig.STORYBLOK_ENV === "draft",
    use: [ apiPlugin ],
    apiOptions: {
      cache: {
        type: "memory",
        clear: "auto",
      },
    },
    components: _components,
  });

  storyblokApi = getStoryblokApiDefault();

  return storyblokApi;
};

export const getStoryblokApi = (): StoryblokClient => storyblokApi ?? AppStoryblokInit(_components);
